import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CCol,
    CRow,
    CCardFooter,
} from '@coreui/react';
import { ThePermission } from '../ThePermission';
import Housings from 'src/views/housings/Housings';
import { housingActions, noteActions, userActions, provinceActions } from 'src/_actions';
import { helps } from 'src/_helpers';

class HousingsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page_header: 'Quản Lý Nhà Đội',
        }
    }

    componentDidMount() {
        if (!this.props.provinces) {
            this.props.getProvinces();
        }

        if (helps.isEmpty(this.props.notes)) {
            this.props.getNotes('housings');
        }

        if (helps.isEmpty(this.props.users)) {
            this.props.getUsers();
        }

        this.props.getAll();
    }

    render() {
        return (
            <ThePermission {... this.props} component="housings" action="view" alertOut={true}>
                <CRow key={helps.convertToSlug(this.state.page_header)}>
                    <CCol xl={12}>
                        <CCard>
                            <CCardHeader>
                                <CRow>
                                    <CCol>
                                        {this.state.page_header}
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCardBody className='housings-table'>
                                <Housings {... this.props} />
                            </CCardBody >
                            <CCardFooter>
                                Tổng: <b>{this.props.housings && <>{this.props.housings.length}</>}</b>
                            </CCardFooter>
                        </CCard >
                    </CCol >
                </CRow >
            </ThePermission>

        );
    }
}

function mapStateToProps(state) {
    const { loading, housings } = state.housingReducer;
    const { provinces } = state.provinceReducer;
    const { users } = state.userReducer;
    const { notes } = state.noteReducer;
    return { loading, housings, provinces, users, notes };
}

const actionCreators = {
    getAll: housingActions.getAll,
    getProvinces: provinceActions.getAll,
    getNotes: noteActions.getAll,
    getUsers: userActions.getAll,
};

const connectedContainer = connect(mapStateToProps, actionCreators)(HousingsContainer);
export { connectedContainer as HousingsContainer };